module.exports = __webpack_public_path__ + "img/wallet-four-big.51d4a322.svg";